import Types from "./Types";

const INITIAL_STATE = {
  courses: [],
  course: {},
  enrollRequests: [],
  enrollCoursesCount: 0,
  isLoading: false,
  count: "",
};

export default function courses(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_COURSES_SUCCESS: {
      return {
        ...state,
        courses: payload.data,
        count: payload.data.length,
      };
    }
    case Types.GET_STUDENT_ENROLL_COURSE_SUCCESS: {
      return {
        ...state,
        enrollRequests: payload.data,
        enrollCoursesCount: payload.data.length,
      };
    }
    case Types.GET_COURSE_SUCCESS: {
      return {
        ...state,
        course: payload,
      };
    }

    case Types.EDIT_COURSE_SUCCESS: {
      let data = payload.data;
      const courses = state.courses;
      let idx = 0;
      courses.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      courses[idx] = data;
      return {
        ...state,
        courses: courses,
      };
    }

    case Types.RESTRICT_COURSE_SUCCESS: {
      let data = payload.data;
      const courses = state.courses;
      let idx = 0;
      courses.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      courses[idx] = data;
      return {
        ...state,
        courses: courses,
      };
    }
    case Types.ASQUARA_COURSE_SUCCESS: {
      let data = payload.data;
      const courses = state.courses;
      let idx = 0;
      courses.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      courses[idx] = data;
      return {
        ...state,
        courses: courses,
      };
    }

    case Types.ACTIVE_COURSE_SUCCESS: {
      let data = payload.data;
      const courses = state.courses;
      let idx = 0;
      courses.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      courses[idx] = data;
      return {
        ...state,
        courses: courses,
      };
    }

    // create
    case Types.CREATE_COURSE_SUCCESS: {
      const data = payload.data.data;
      let newArray = state.courses.slice();
      let index = state.courses.length + 1;
      newArray.splice(index, 0, data);
      return {
        ...state,
        courses: newArray,
        count: state.count + 1,
      };
    }
    case Types.ADD_COURSES_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.DELETE_COURSE_SUCCESS: {
      const newcourses = state.courses.filter((item) => item.id !== payload);
      return {
        ...state,
        courses: newcourses,
        count: state.count - 1,
      };
    }
    case Types.APPROVE_SUPERADMIN_STUDENT_ENROLL_COURSE_SUCCESS: {
      let data = payload.data;
      const enrollRequests = state.enrollRequests;
      let idx = 0;
      enrollRequests.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      enrollRequests[idx] = data;
      return {
        ...state,
        enrollRequests: enrollRequests,
      };
    }
    case Types.REJECT_SUPERADMIN_STUDENT_ENROLL_COURSE_SUCCESS: {
      let data = payload.data;
      const enrollRequests = state.enrollRequests;
      let idx = 0;
      enrollRequests.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      enrollRequests[idx] = data;
      return {
        ...state,
        enrollRequests: enrollRequests,
      };
    }
    default: {
      return state;
    }
  }
}
